import {createDivIn, createHeaderIn, createLinkIn, createParagraphIn, createSpanIn} from '../ui_utils/DomUtils'
import {PatchNote, PatchNoteContent, PatchNoteType} from './UIPatchNoteModule'
import {getProfileURI} from '../ui_utils/TestableClientUtils'
import {TimeUtils} from '../../../../shared/utils/TimeUtils'
import {TranslationObject} from '@colonist/i18n'

export class PatchNoteView {
    constructor(pn: PatchNote, container: HTMLElement, sidebarContainer: HTMLElement | null, divClass: string, headerClass: string, bodyClass: string) {
        const dateTextId = TimeUtils.getDate(pn.date)

        const dateFormatParams = {year: 'numeric', month: 'short', day: 'numeric'}
        const dateTitleText: TranslationObject = {
            key: 'strings:colonistCommon.utils.#date',
            options: {
                value: pn.date,
                formatParams: {
                    value: dateFormatParams,
                },
            },
        }
        const dateSidebarText: TranslationObject = {
            key: 'strings:popups.patchNote.versionDate',
            options: {
                version: pn.version,
                date: pn.date,
                formatParams: {
                    date: dateFormatParams,
                },
            },
        }

        const pndiv = createDivIn(container, divClass, dateTextId)
        const headerDiv = createDivIn(pndiv, headerClass)

        const dateTitle = createHeaderIn(headerDiv, dateTitleText, 'pn-title-date', dateTextId, 'H2')
        if(sidebarContainer !== null) {
            const sidebarLink = createLinkIn(sidebarContainer, '#' + dateTextId, dateSidebarText, 'singleton_page_sidebar_button')
        }
        const versionTitle = createHeaderIn(headerDiv, {key: 'strings:popups.patchNote.version', options: {version: pn.version}}, 'pn-title-version', '', 'H4')
        const bodyDiv = createDivIn(pndiv, bodyClass, '')

        for(const content of pn.contents) {
            const contentDiv = createDivIn(bodyDiv, 'content', '')
            if(content.type == PatchNoteType.Category) {
                createHeaderIn(contentDiv, {key: 'strings:colonistCommon.utils.#buffer', options: {value: content.description}}, '', '', 'H3')
                continue
            }

            PatchNoteView.createContentType(content, contentDiv)

            let extraText = PatchNoteView.getContributorText(content.contributors)
            if(content.beforeImgUrl != undefined || content.afterImgUrl != undefined) extraText += ' ('
            if(content.beforeImgUrl != undefined) extraText += 'Before:<a href="' + content.beforeImgUrl + '" target="_blank"> 🌅 </a> '
            if(content.afterImgUrl != undefined) extraText += 'After:<a href="' + content.afterImgUrl + '" target="_blank"> 🌅 </a>'
            if(content.beforeImgUrl != undefined || content.afterImgUrl != undefined) extraText += ')'

            const paragraph = createParagraphIn(contentDiv, {key: 'strings:colonistCommon.utils.emptyString'}, '')
            // eslint-disable-next-line no-restricted-syntax
            paragraph.innerHTML += content.description
            // eslint-disable-next-line no-restricted-syntax
            paragraph.innerHTML += extraText
        }
    }

    private static createContentType(content: PatchNoteContent, div: HTMLDivElement) {
        if(content.links == undefined) {
            createSpanIn(div, PatchNoteView.getTypeClass(content.type), {key: 'strings:colonistCommon.utils.#buffer', options: {value: content.type.toString()}})
            return
        }
        if(content.links.length == 0) createSpanIn(div, PatchNoteView.getTypeClass(content.type), {key: 'strings:colonistCommon.utils.#buffer', options: {value: content.type.toString()}})
        const link = createLinkIn(div, content.links[0], {key: 'strings:colonistCommon.utils.#buffer', options: {value: content.type.toString()}}, PatchNoteView.getTypeClass(content.type))
        link.target = '_blank'
        link.style.textDecoration = 'underline'
    }

    private static getContributorText(contributors: string[]): string {
        if(contributors.length == 0) return ''
        let text = ' (Thanks'
        for(const [index, contributor] of contributors.entries()) {
            text += ' <a href="' + getProfileURI(contributor) + '" target="_blank">' + contributor + '</a>'
            if(index != contributors.length - 1) text += ','
        }
        return text + ')'
    }

    private static getTypeClass(type: PatchNoteType): string {
        switch(type) {
            case PatchNoteType.Feature:
                return 'pntype-feature'
            case PatchNoteType.Update:
                return 'pntype-update'
            case PatchNoteType.Blog:
                return 'pntype-blog'
            case PatchNoteType.Fix:
                return 'pntype-fix'
            case PatchNoteType.Category:
                return 'pntype-update'
            case PatchNoteType.Youtube:
                return 'pntype-youtube'
        }
    }
}
